module.exports = __webpack_public_path__ + "static/media/jewellery.d86999f3.jpg";